/* v17 · os botões flutuantes (Lojas/Ajuda/WhatsApp) nunca tapam botões da página: se se sobrepõem a um CTA, recolhem-se até o CTA passar */
(function () {
  var Q = 'main a.button, main button, main .button, main input[type=submit]';
  var t = 0;
  function chk() {
    t = 0; var f = document.querySelector('.kyf'); if (!f) return;
    var r = f.getBoundingClientRect(); if (!r.width) return; var hit = false;
    var els = document.querySelectorAll(Q);
    for (var i = 0; i < els.length && !hit; i++) {
      var e = els[i]; if (f.contains(e)) continue; var b = e.getBoundingClientRect();
      if (b.width && b.height && b.bottom > r.top - 6 && b.top < r.bottom + 6 && b.right > r.left - 6 && b.left < r.right + 6 && getComputedStyle(e).visibility !== 'hidden') hit = true;
    }
    f.classList.toggle('kyf--away', hit);
  }
  function q() { if (!t) t = requestAnimationFrame(chk); }
  addEventListener('scroll', q, { passive: true }); addEventListener('resize', q); addEventListener('load', q); setInterval(q, 800);
})();
